/**********************************************************
Chemical List: Lists all chemical products in the database
7/22/19
chemicalList: Array of chemical products
**********************************************************/
import React from 'react';

const ChemicalList = ({ chemicalList, onClick }) => {
  if (!chemicalList) return <span>No Products Available</span>;
  return (
    <div className="card">
      <ul className="collection">
        {
          chemicalList.map((c) => (
            <li key={c.id} className="collection-item chem-list-item" onClick={() => onClick(c)}>
              <span><b>{ c.name }</b> - { c.type }</span>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

export default ChemicalList;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chemical/chemical_list.js